import { useEffect } from "react";
import { Form } from "antd";
import { useAtom } from "jotai";
import { frmPreguntasProductividadEficienciaAtom, puntajeTotalProductividadEficienciaAtom } from "../../BandejaEvaluacionStorage";

const usePreguntasProductividadEficiencia = () => {
	const [puntajeTotal, setPuntajeTotal] = useAtom(puntajeTotalProductividadEficienciaAtom);
	const [frmPreguntas, setFrmPreguntas] = useAtom(frmPreguntasProductividadEficienciaAtom);
	const [form] = Form.useForm();

	useEffect(() => {
		if (!frmPreguntas) {
			setFrmPreguntas(form);
		}
	}, []);

	return { frmPreguntas, puntajeTotal, setPuntajeTotal };
};

export default usePreguntasProductividadEficiencia;
